import { HIDE_SELL_MODAL } from './../../actions/index';
import {
  SHOW_ORDER_SUBMIT_MODAL,
  HIDE_ORDER_SUBMIT_MODAL,
  SHOW_ORDER_SUBMITTED_MODAL,
  HIDE_ORDER_SUBMITTED_MODAL,
  TOGGLE_FIRST_LOGIN_MODAL,
  SHOW_SELL_SUBMITTED_MODAL,
  HIDE_SELL_SUBMITTED_MODAL,
  SHOW_POSITION_DETAIL_MODAL,
  HIDE_POSITION_DETAIL_MODAL,
  SHOW_WITHDRAW_SUBMITTED_MODAL,
  HIDE_WITHDRAW_SUBMITTED_MODAL,
  Action,
  SHOW_SELL_MODAL,
} from 'actions';

import { State as SharedState } from 'shared/components/ModalContainer/reducers';

export interface State {
  visible?:
    | 'orderSubmit'
    | 'orderSubmitted'
    | 'firstLogin'
    | 'sellStock'
    | 'sellIdea'
    | 'sellSubmitted'
    | 'positionDetailsIdea'
    | 'positionDetailsStock'
    | 'withdrawSubmitted'
    | SharedState['visible'];

  currency?: string;
  amount?: number;
}

export default (state: State = {}, action: Action): State => {
  switch (action.type) {
    case HIDE_ORDER_SUBMIT_MODAL:
      return state.visible === 'orderSubmit' ? {} : state;
    case SHOW_ORDER_SUBMIT_MODAL:
      return { visible: 'orderSubmit' };
    case HIDE_ORDER_SUBMITTED_MODAL:
      return state.visible === 'orderSubmitted' ? {} : state;
    case SHOW_ORDER_SUBMITTED_MODAL:
      return { visible: 'orderSubmitted' };
    case TOGGLE_FIRST_LOGIN_MODAL:
      if (!action.payload.visible) {
        return state.visible === 'firstLogin' ? {} : state;
      }
      return { visible: 'firstLogin' };

    case SHOW_SELL_MODAL:
      return { visible: action.payload.domain === 'STOCK' ? 'sellStock' : 'sellIdea' };
    case HIDE_SELL_MODAL:
      return state.visible === 'sellIdea' || state.visible === 'sellStock' ? {} : state;

    case SHOW_SELL_SUBMITTED_MODAL:
      return { visible: 'sellSubmitted' };
    case HIDE_SELL_SUBMITTED_MODAL:
      return state.visible === 'sellSubmitted' ? {} : state;

    case SHOW_POSITION_DETAIL_MODAL:
      return {
        visible: action.payload.domain === 'STOCK' ? 'positionDetailsStock' : 'positionDetailsIdea',
      };
    case HIDE_POSITION_DETAIL_MODAL:
      return state.visible === 'positionDetailsStock' || state.visible === 'positionDetailsIdea'
        ? {}
        : state;

    case SHOW_WITHDRAW_SUBMITTED_MODAL:
      return { visible: 'withdrawSubmitted' };
    case HIDE_WITHDRAW_SUBMITTED_MODAL:
      return state.visible === 'withdrawSubmitted' ? {} : state;

    default:
      return state;
  }
};
